/** Wire schema version. The HTTP endpoint stays /player/input/v2. */
export const ACTION_SCHEMA_VERSION = 1;
export const ACTION_ENDPOINT_PATH = '/player/input/v2';
export const MAX_ACTION_REQUEST_BYTES = 32 * 1024;
